export const COMPENSATION_HINT_SESSION_STORAGE_KEY =
  'compensation_hint_is_hidden';
